import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ActivityFeedService } from '../../../client/services/activity-feed.service';
import {
  ActivityFeedItem,
  ActivityPeriod
} from '../../../client/models/activity-feed.model';

@Component({
  selector: 'app-applicant-activity',
  templateUrl: './applicant-activity.component.html',
  styleUrls: ['./applicant-activity.component.scss']
})
export class ApplicantActivityComponent implements OnInit, OnDestroy, OnChanges {
  @Input() candidateId!: number;

  activities: ActivityFeedItem[] = [];
  isLoading = false;
  selectedPeriod: ActivityPeriod = '7d';

  private destroy$ = new Subject<void>();

  constructor(private activityFeedService: ActivityFeedService) {}

  ngOnInit(): void {
    if (this.candidateId) {
      this.loadActivities();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['candidateId'] && !changes['candidateId'].firstChange) {
      this.loadActivities();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadActivities(): void {
    if (!this.candidateId) return;

    this.isLoading = true;

    this.activityFeedService
      .getCandidateFeed(this.candidateId, this.selectedPeriod)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (activities) => {
          this.activities = activities;
          this.isLoading = false;
        },
        error: () => {
          this.activities = [];
          this.isLoading = false;
        }
      });
  }

  onPeriodChange(event: MatButtonToggleChange): void {
    this.selectedPeriod = event.value;
    this.loadActivities();
  }

  getActivityIcon(type: string): string {
    return this.activityFeedService.getActivityIcon(type);
  }

  getActivityColor(type: string): string {
    return this.activityFeedService.getActivityColor(type);
  }

  getActivityDetail(activity: ActivityFeedItem): string | null {
    return this.activityFeedService.getActivityDetail(activity);
  }

  getSummaryKey(activityType: string): string {
    return this.activityFeedService.getSummaryKey(activityType);
  }

  getSummaryParams(activity: ActivityFeedItem): Record<string, string> {
    return this.activityFeedService.getSummaryParams(activity);
  }
}
